// Accessibility page translations
const accessibilityTranslations = {
  en: {
    hero: {
      kicker: "accessibility / thewhizkind",
      title: "accessibility",
      subtitle: "access isn't an extra."
    },
    sections: {
      builtIn: {
        index: "01",
        title: "built in, not switched on.",
        content: [
          "the web is meant to be used by people: different people, using different devices, different ways of navigating and different ways of experiencing what's on a screen.",
          "we believe accessibility is part of good design, not something added after the design is finished.",
          "that's why thewhizkind is being built with <strong>WCAG 2.2 Level AA</strong> as its accessibility target. accessibility considerations are part of the structure, navigation, interactions, colour contrast, motion and content of the website itself.",
          "the default experience is designed to support keyboard navigation, screen readers, visible focus states, sufficient colour contrast, scalable content, semantic structure and reduced-motion preferences.",
          "the accessibility controls you see on the website don't make thewhizkind accessible. they're there because different people have different preferences.",
          { emphasis: "accessibility starts before those controls do." }
        ]
      },
      preferences: {
        index: "02",
        title: "one web. different ways to use it.",
        content: [
          "on top of the accessible baseline, you can adapt parts of the experience to suit you. accessibility preferences are always available in the bottom-right corner of the website.",
          "changes take effect immediately. your choices are stored locally in your browser and can be changed or reset at any time. accessibility preferences aren't sent to us."
        ],
        preferences: [
          {
            title: "larger text",
            description: "increases text size across the website."
          },
          {
            title: "higher contrast",
            description: "increases visual contrast beyond the standard presentation."
          },
          {
            title: "reduce motion",
            description: "reduces non-essential movement and animation."
          },
          {
            title: "underline links",
            description: "makes text links easier to distinguish from surrounding content."
          }
        ]
      },
      contact: {
        index: "03",
        title: "we're still learning.",
        content: [
          "accessibility isn't a box we consider checked.",
          "websites change. standards evolve. automated tests can only tell us so much about how something actually feels to use.",
          "we'll continue reviewing and improving thewhizkind as it develops.",
          "if you encounter a barrier, whether something is difficult to navigate, read, understand or operate, we'd like to hear about it."
        ],
        email: "prayrit@thewhizkind.com",
        emphasis: "if we can make it better, we will."
      }
    }
  },
  de: {
    hero: {
      kicker: "barrierefreiheit / thewhizkind",
      title: "barrierefreiheit",
      subtitle: "zugänglichkeit ist kein extra."
    },
    sections: {
      builtIn: {
        index: "01",
        title: "eingebaut, nicht eingeschaltet.",
        content: [
          "das web soll von menschen genutzt werden: unterschiedliche menschen, die unterschiedliche geräte nutzen, unterschiedliche wege der navigation und unterschiedliche arten, das, was auf dem bildschirm zu sehen ist, zu erleben.",
          "wir glauben, dass barrierefreiheit ein teil von gutem design ist, nicht etwas, das nachträglich hinzugefügt wird.",
          "deshalb wird thewhizkind mit <strong>WCAG 2.2 Level AA</strong> als barrierefreiheits-ziel entwickelt. barrierefreiheits-überlegungen sind teil der struktur, navigation, interaktionen, farbkontraste, bewegung und inhalte der website selbst.",
          "das standard-erlebnis ist so gestaltet, dass es tastatur-navigation, screenreader, sichtbare fokus-zustände, ausreichenden farbkontrast, skalierbare inhalte, semantische struktur und präferenzen für reduzierte bewegung unterstützt.",
          "die barrierefreiheits-steuerungen, die du auf der website siehst, machen thewhizkind nicht barrierefrei. sie sind da, weil verschiedene menschen unterschiedliche präferenzen haben.",
          { emphasis: "barrierefreiheit beginnt vor diesen steuerungen." }
        ]
      },
      preferences: {
        index: "02",
        title: "ein web. verschiedene nutzungsmöglichkeiten.",
        content: [
          "zusätzlich zur barrierefreien basis kannst du teile des erlebnisses an deine bedürfnisse anpassen. barrierefreiheits-präferenzen sind immer im untersten rechten eck der website verfügbar.",
          "änderungen treten sofort in kraft. deine auswahl wird lokal in deinem browser gespeichert und kann jederzeit geändert oder zurückgesetzt werden. barrierefreiheits-präferenzen werden nicht an uns gesendet."
        ],
        preferences: [
          {
            title: "größerer text",
            description: "erhöht die textgröße auf der gesamten website."
          },
          {
            title: "höherer kontrast",
            description: "erhöht den visuellen kontrast über die standard-präsentation hinaus."
          },
          {
            title: "bewegung reduzieren",
            description: "reduziert unnötige bewegung und animationen."
          },
          {
            title: "links unterstreichen",
            description: "macht textlinks leichter vom umgebenden inhalt zu unterscheiden."
          }
        ]
      },
      contact: {
        index: "03",
        title: "wir lernen noch.",
        content: [
          "barrierefreiheit ist für uns kein abgehaktes kästchen.",
          "websites verändern sich. standards entwickeln sich weiter. automatisierte tests können uns nur begrenzt verraten, wie sich etwas bei der tatsächlichen nutzung anfühlt.",
          "wir werden thewhizkind weiterhin überprüfen und verbessern, während es sich entwickelt.",
          "wenn du auf eine barriere stößt, sei es bei der navigation, beim lesen, verstehen oder bedienen, möchten wir davon erfahren."
        ],
        email: "prayrit@thewhizkind.com",
        emphasis: "wenn wir es besser machen können, werden wir es tun."
      }
    }
  }
};

export default accessibilityTranslations;